module.exports = __webpack_public_path__ + "static/media/404-back-min.191b4173.jpg";